import { LitElement, nothing, PropertyValues } from 'lit';
import {customElement, property} from 'lit/decorators';

import Debug from 'debug';
import { dataBroker } from '../services/DataBroker';
import { notificationService } from '../services/notificationService';


const log = Debug('pdq:flow:pdq-pagination');
@customElement('pdq-pagination')
export class PdqPagination extends LitElement {
    static styles = []
    private _configKey: string = '';

    @property({type: String})
    id: string = ''

    @property({type: String})
    source: string = ''

    private _page = 1;
    @property({type: Number, reflect: true})
    get page() {
        return this._page
    }
    set page(value) {
        log(`set page=${value}`);
        if (value != this._page && value > 0) {
            this._page = value;
            if (this._configKey)
                dataBroker.setDataSource(this._configKey, {page: this._page, pageSize: this.pageSize})
                    .catch(e => log(`failed to set datasource[${this._configKey}] - ${e}`))
        }
    }

    private _pageSize = 100;
    @property({type: Number, reflect: true, attribute: "page-size"})
    get pageSize() {
        return this._pageSize
    }
    set pageSize(value) {
        log(`set pageSize=${value}`);
        if (value != this._pageSize && value > 0) {
            this._pageSize = value;
            if (this._configKey)
                dataBroker.setDataSource(this._configKey, {page: this._page, pageSize: this.pageSize})
                  .catch(e => log(`failed to set datasource[${this._configKey}] - ${e}`))
        }
    }

    protected firstUpdated(_changedProperties: PropertyValues) {
        log(`firstUpdated`);
        super.firstUpdated(_changedProperties);
        this.sync().catch(e => log(`failed to set sync - ${e}`));
    }
    protected updated(_changedProperties: PropertyValues) {
        log(`updated`);
        super.updated(_changedProperties);
        this.sync().catch(e => log(`failed to set sync - ${e}`));
    }

    _cacheKey = ''
    async sync() {
        log(`sync`, this.id, this.source);
        if (!this.source || !this.id) {
            log('source or id not set, sync not required')
            return
        }
        if (this._cacheKey == `${this.source}##${this.id}`)
            return
        this._cacheKey = `${this.source}##${this.id}`


        this._configKey = `${this.id}__page_config`

        try {
            log(`setting DataSource for pageConfig`)
            await dataBroker.setDataSource(this._configKey, {page: this._page, pageSize: this.pageSize})
            log('adding derivation');
            await dataBroker.upsertDerivation(this.id, [this._configKey, this.source], this.paginate as any)

            log(`sync complete`)
        } catch (e) {
            log(`failed to add derivation: ${e}`)
            notificationService.warning(`failed to add derivation ${this.id}: ${e}`)
        }
    }
    protected async paginate<T>(args: PaginationSources): Promise<PaginationPage<T>> {
        const [{page, pageSize}, data] = args;
        const start = (page-1)*pageSize
        const end = page*pageSize

        return {
          page,
          pageSize,
          start,
          end,
          totalItems: data.length,
          items: data.slice(start, end)
        }
    }
    render = ()  => nothing
}

export interface PaginationConfig {
    page: number;
    pageSize: number;
}
type PaginationSources = [PaginationConfig, any[]]
export interface PaginationPage<T> extends PaginationConfig {
    items: T[]
    start: number
    end: number
    totalItems: number
}